export default __webpack_public_path__ + "assets/mission.230b5c1a8ecbadce8342059b693e7e43.png";